// Red "under 3T / PPR Needed" badge for arriving flights to EBCI with MTOW < 3000 kg.
// Only shown for arrivals (destination EBCI, origin not EBCI). Never for departures.
export const PprBadge = ({ flight }) => {
  const dest = (flight?.destination || "").toUpperCase();
  const origin = (flight?.origin || "").toUpperCase();
  const isArrival = dest === "EBCI" && origin !== "EBCI";
  const mtow = Number(flight?.mtow) || 0;
  if (!isArrival || mtow <= 0 || mtow >= 3000) return null;
  return (
    <span
      data-testid={`ppr-badge-${flight?.id || flight?.registration || ""}`}
      className="px-3 py-1 bg-red-600 text-white text-xs font-bold rounded-full whitespace-nowrap"
      title="Aircraft MTOW under 3000 kg — Prior Permission Required"
    >
      PPR Needed
    </span>
  );
};
